import { useEffect, useState } from "react";
// import { informationToast, errorToast } from '../../../../utils/Toast/index';

function getDaysInMonth(year, month) {
  return new Date(year, month + 1, 0).getDate();
}

function getMonthName(month) {
  return new Date(2000, month, 1).toLocaleString("default", { month: "long" });
}

const today = new Date();

const initialBookings = {};

export default function ManagerRoomMonthView(props) {
  const localMonth = today.getMonth();
  const localYear = today.getFullYear();
  const [bookings, setBookings] = useState(initialBookings);

  const currentMonth = props.currentMonth ?? localMonth;
  const currentYear = props.currentYear ?? localYear;
  const daysInMonth = getDaysInMonth(currentYear, currentMonth);

  const { listRoom, percentSale, overrides, listAutoUpdate, setSaleOverrides } = props;

  useEffect(() => {
    if(overrides) console.log("vo here"); setSaleOverrides(overrides);
  },[overrides, setSaleOverrides])

  const toggleBooking = (roomId, day) => {
    setBookings((prev) => {
      const updated = { ...prev };
      const roomBookings = updated[roomId] || {};
      updated[roomId] = { ...roomBookings, [day]: !roomBookings[day] };
      return updated;
    });
  };

  const toggleAutoDay = (key, day) => {
   // setAutoUpdate(prev => ({ ...prev, [key]: !prev[key] }));
    props.setListAutoUpdate(prev => {
      const copy = prev.slice();
      copy[day - 1] = !copy[day - 1];
      return copy;
    });
  };

  const isDayPassed = (day) => {
    const todayDate = today.getDate();
    const todayMonth = today.getMonth();
    const todayYear = today.getFullYear();
    if (currentYear < todayYear) return true;
    if (currentYear > todayYear) return false;
    if (currentMonth < todayMonth) return true;
    if (currentMonth > todayMonth) return false;
    return day < todayDate;
  };

  const getDayOfWeek = (day) => {
    const date = new Date(currentYear, currentMonth, day);
    return date.toLocaleString("en-US", { weekday: "short" });
  };

  // Helper to render a table for a given day range
  const renderTable = (startDay, endDay, tableId) => (
    <div style={{ overflowX: "auto", marginBottom: 24 }}>
      <table style={{ borderCollapse: "collapse", minWidth: 900 }}>
        <thead>
          <tr>
            <th style={{ position: "sticky", left: 0, background: "#fff", zIndex: 2, width: "230px", border:"1.5px solid", fontSize: "1.4rem" }}>Room Type</th>
            <th style={{ position: "sticky", left: 0, background: "#fff", zIndex: 2, width: "70px", border:"1.5px solid" }}>Room</th>

            {[...Array(endDay - startDay + 1)].map((_, i) => (
              <th key={i} style={{ minWidth: 32, width: "90px", border:"1.5px solid", fontSize: "1.4rem"  }}>
                {startDay + i} <br /> {getDayOfWeek(startDay + i)}
                {percentSale[startDay + i] !== undefined && (
                  <span style={{ 
                    display: "block", 
                    fontSize: "1.3rem", 
                    color: percentSale[startDay + i] === 50 ? "green" : percentSale[startDay + i] === 80 ? "orange" : "red" 
                  }}>
                    ({percentSale[startDay + i]}%)
                  </span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {listRoom && typeof listRoom === 'object' ? (
            Object.entries(listRoom).flatMap(([typeKey, data]) => {
              // two rows: Can Sale (50% rule) and Available
              const m = typeKey.match(/(.+)\s(\d+)$/);
              const name = m[1];
              const price = Number(m[2]);

              const canSaleRow = (
                <tr key={typeKey + "-can-sale"}>
                  <td style={{ 
                      position: "sticky", 
                      left: 0, 
                      background: "#d8f3f9", 
                      zIndex: 1, 
                      border: "1.5px solid", 
                    }} rowSpan={2}>
                    <div style={{fontWeight:"600"}}>{name} </div>
                    <span style={{fontSize:"1.1rem", fontStyle:"italic"}}>Price: {price.toLocaleString()} Vnd - total: {listRoom[typeKey].total}</span>
                  </td>

                  <td style={{borderTop:"1.5px solid", borderRight:"1.5px solid", borderBottom:"1px solid"}}>Sale</td>    
                  {[...Array(endDay - startDay + 1)].map((_, i) => {
                    const day = startDay + i;
                    const avail = data.days[day] //data && data.days && data.days[day] !== undefined ? Number(data.days[day]) : 0;
                    const saleOnServer = data.sale[day]//data && data.sale && data.sale[day] !== undefined ? Number(data.sale[day]) : 0;
                    const canSale = avail //avail <= 1 ? 0 : Math.floor(avail * 0.5);
                    const overrideVal = saleOnServer;//saleOverrides[overrideKey];
                    // const displaySale = (overrideVal !== undefined && listAutoUpdate[day-1] === true)? overrideVal : canSale;
                    const displaySale = (saleOnServer !== undefined && listAutoUpdate[day-1] === true)? overrideVal : canSale;
                    const passed = isDayPassed(day);

                    // function checkSetupByUser() {
                    //   if(overrideKey in saleOverrides) {
                    //         return saleOverrides[overrideKey]
                    //         // const [name, day] = key.split("-");
                    //         // if (!overridesReturn[name]) {
                    //         //     overridesReturn[name] = {};
                    //         // }
                    //         // overridesReturn[name][day] = saleRoomData.overrides[key];
                    //   } else return null;
                    // }
                    
                    return (
                      <td
                        key={"can-" + i}
                        style={{
                          border: "1px solid #ccc",
                          background: passed ? "#f5f5f5" : (canSale === 0 ? "#ffb3b3" : "#e6ffe6"),
                          width: "50px",
                          textAlign: 'center',
                          borderTop: "1.5px solid",
                          borderRight: i === (startDay === 1 ? 14 : endDay -16) ? "1.5px solid" : "unset"
                        }}
                      >
                        {listAutoUpdate[day-1] ? (
                          <input
                            type="number"
                            value={displaySale}
                            min={0}
                            max={avail}
                            disabled={avail === 0 || passed}
                            onChange={(e) => props.onChangeSaleRoom(e.target.value, typeKey, day, data.days[day])
                              // {
                              // const raw = Number(e.target.value);
                              // const v = isNaN(raw) ? 0 : raw;
                              // const clamped = Math.max(0, Math.min(v, avail));
                              //   setSaleOverrides(prev => ({ ...prev, [overrideKey]: clamped }));
                              // }
                            }
                            style={{ width: 46, textAlign: 'center' }}
                          />
                        ) : (
                          saleOnServer//displaySale > avail ? avail : saleOnServer
                        )}
                      </td>
                    );
                  })}
                </tr>
              );

              const availRow = (
                <tr key={typeKey + "-avail"}>
                  <td style={{borderRight:"1.5px solid", borderBottom: "1.5px solid", borderLeft:"1.5px solid", }}>Available</td>
                  {/* <td style={{ position: "sticky", left: 0, background: "#fff", zIndex: 1, fontWeight: 600 }}>{typeKey} (Available)</td> */}
                  {[...Array(endDay - startDay + 1)].map((_, i) => {
                    const day = startDay + i;
                    const val = data && data.days && data.days[day] !== undefined ? Number(data.days[day]) : 0;
                    const passed = isDayPassed(day);
                    return (
                      <td
                        key={"avail-" + i}
                        style={{
                          border: "1px solid #ccc",
                          background: passed ? "#f5f5f5" : (val === 0 ? "#ffb3b3" : "#e6ffe6"),
                          width: "50px",
                          textColor: "red",
                          textAlign: 'center',
                          borderBottom: "1.5px solid",
                          borderRight: i === (startDay === 1 ? 14 : endDay -16) ? "1.5px solid" : "unset"
                        }}
                      >
                        {val}
                      </td>
                    );
                  })}
                </tr>
              );

              return [canSaleRow, availRow];
            })
          ) : Array.isArray(listRoom) ? (
            listRoom.map((room, index) => (
              <tr key={index}>
                <td style={{ position: "sticky", left: 0, background: "#f9f9f9", zIndex: 1, fontWeight: 600 }}>
                  <div>{room.name}</div>
                  <div style={{ fontStyle: 'italic', fontSize: '0.95rem' }}>Price: {room.price?.toLocaleString()} Vnd - Total: {room.total}</div>
                </td>
                {[...Array(endDay - startDay + 1)].map((_, i) => {
                  const day = startDay + i;
                  const isBooked = bookings[index] && bookings[index][day];
                  return (
                    <td
                      key={i}
                      style={{
                        border: "1px solid #ccc",
                        background: isBooked ? "#ffb3b3" : "#e6ffe6",
                        cursor: "pointer",
                        width: "70px",
                        textAlign: 'center',
                        // borderRight: i === endDay-1 ? "1.5px solid" : "unset"
                      }}
                      onClick={() => toggleBooking(index, day)}
                    >
                      {isBooked ? "Booked" : ""}
                    </td>
                  );
                })}
              </tr>
            ))
          ) : null}

          <tr>
            <td colSpan={2} style={{textAlign:"end"}}>Auto Update ?</td>
              {[...Array(endDay - startDay + 1)].map((_, i) => {
              const day = startDay + i;
              const key = `${tableId}-${day}`;
              const passed = isDayPassed(day);
              let listEnabled = !!listAutoUpdate[day - 1];
              
              // Nếu ngày đã qua, reset về false
              if (passed && listEnabled) {
                listEnabled = false;
                props.setListAutoUpdate(prev => {
                  const copy = prev.slice();
                  copy[day - 1] = false;
                  return copy;
                });
              }
              
              return (
                <td key={"autoupdate-" + i} style={{ textAlign: 'center', borderBottom: "1.5px solid" }}>
                  {(() => {
                    if (passed) {
                      return (
                        <div style={{ cursor: "not-allowed", opacity: 0.5, color: '#666' }}>
                          Off
                        </div>
                      );
                    }
                    return (
                      <div onClick={() => toggleAutoDay(key, day)}
                           style={{ cursor: "pointer", color: listEnabled ? "white" : "unset", background: listEnabled ? "red" : "unset" }}>
                        {listEnabled ? 'On' : 'Off'}
                      </div>
                    );
                  })()}
                </td>
              );
            })}
          </tr>
        </tbody>
      </table>
    </div>
  );

  return (
    <div style={{ padding: "12px 24px" }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 16 }}>
        <button onClick={props.onPrevMonth ?? (() => {})} disabled={props.loading}>&lt;</button>
        <h3 style={{ margin: "0 16px" }}>
          {getMonthName(currentMonth)} {currentYear}{props.loading ? ' (Loading...)' : ''}
        </h3>
        <button onClick={props.onNextMonth ?? (() => {})} disabled={props.loading}>&gt;</button>
      </div>
      {/* Days 1-15 */}
      {(listRoom && (Array.isArray(listRoom) ? listRoom.length > 0 : Object.keys(listRoom).length > 0)) && renderTable(1, Math.min(15, daysInMonth), 'first')}
      {/* Days 16-end */}
      {daysInMonth > 15 && (listRoom && (Array.isArray(listRoom) ? listRoom.length > 0 : Object.keys(listRoom).length > 0)) && renderTable(16, daysInMonth, 'second')}
      {/* <div style={{ marginTop: 16, color: "#888" }}>
        <small>Developed by the IT team</small>
      </div> */}
    </div>
  );
}
